import { makeStyles } from "@material-ui/core";

const NenhumaDespesaEncontradaGroupPayStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '4rem 2rem',
    gap: '1rem',
  },
  icon: {
    fontSize: '20px',
    color: '#263949',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: 'rgba(38, 57, 73, 0.12)',
    borderRadius: '5px',
  },
  title: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#676A6C',
    marginBottom: '0.5rem',
  },
  subtitle: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '1.5',
    color: '#676A6C',
    maxWidth: '470px',
  },
}))

export default NenhumaDespesaEncontradaGroupPayStyles;